<template>
    <div>
        <BreadCrumb :data="breadCrumb" />
          <b-card>
             <form-wizard 
                title=""
                subtitle=""
                :back-button-text="$t('account.wizzard.prev')"
                :next-button-text="$t('account.wizzard.next')"
                :finish-button-text="$t('account.wizzard.complate')"
                color="#007bff"
                @on-change="handleTabChange" 
                :start-index="message.status === 'Success' ? selectedIndex : 0" 
                ref="wizzard">
                <template slot="step" slot-scope="props">
                    <wizard-step :tab="props.tab"
                    :transition="props.transition"
                    :key="props.tab.title"
                    :index="props.index">
                    </wizard-step>
                </template>
                <template slot="footer" slot-scope="props">
                    <div class="wizard-footer-left">
                        <wizard-button  v-if="props.activeTabIndex " @click.native="props.prevTab()" :style="props.fillButtonStyle"> {{ $t('customer.wizzard.prev') }} </wizard-button>
                    </div>
                    <div class="wizard-footer-right">
                        <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle"> {{ $t('account.wizzard.next') }} </wizard-button>
                        <wizard-button v-else @click.native="() => onComplete(props.isLastStep)" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">  {{$t('account.wizzard.complete')}}</wizard-button>
                    </div>
                </template>

                <tab-content :title="$t('account.wizzard.generalInfo')" icon="ti-info-alt" class="formGroup" :before-change="changeStep">
                    <Form ref="GeneralForm" :loading="loading" :customer="{data: $route.params.id }" :forms="GeneralForms" />
                </tab-content>
                <tab-content :title="$t('account.wizzard.zones')" icon="ti-layout-grid2"> 
                    <div class="actions">
                        <b-button variant="success"  @click="openModal(true,'add',accountId)"> <b-icon icon="plus" /> {{$t('general.add')}} </b-button>
                    </div>
                    <ZoneForm :modalType="pageSettings" :modalEvent="openModal" />
                </tab-content>
                <tab-content :title="$t('account.wizzard.workHours')"  icon="ti-time">
                    <div class="actions">
                        <b-button variant="success"  @click="openModal(true,'add')"> <b-icon icon="plus" />{{$t('general.add')}}</b-button>
                    </div>
                    <WorkHours :edit="true" :modalType="pageSettings" :modalEvent="openModal" :hourList="hourList ? hourList : []"/>
                </tab-content>
                <tab-content :title="$t('account.wizzard.alarmState')" icon="ti-bell">
                    <div class="actions">
                        <b-button variant="success"  @click="openModal(true,'add')"> <b-icon icon="plus" />{{$t('general.add')}}</b-button>
                    </div>
                   <Exceptions :modalType="pageSettings" :modalEvent="openModal" />
                </tab-content>
                <tab-content :title="$t('account.wizzard.panelUsers')" icon="ti-user">
                    <div class="actions">
                        <b-button variant="success"  @click="openModal(true,'add', {type: 0})"> <b-icon icon="plus" /> {{$t('general.add')}} </b-button>
                    </div>
                    <PanelUsersForm :modalType="pageSettings" :modalEvent="openModal" />
                </tab-content>
                <tab-content :title="$t('account.wizzard.notifications')" icon="ti-comments">
                    <div class="actions">
                        <b-button variant="success"  @click="openModal(true,'add',{type: '1'})"> <b-icon icon="plus" /> {{$t('general.add')}} </b-button>
                    </div>
                    <NotificationForm :modalType="pageSettings" :modalEvent="openModal" />
                </tab-content>
                <tab-content :title="$t('account.wizzard.notes')" icon="ti-clipboard">
                    <div class="actions">
                        <b-button variant="success"  @click="openModal(true,'add')"> <b-icon icon="plus" /> {{$t('general.add')}} </b-button>
                    </div>
                    <NoteForm :modalType="pageSettings" :modalEvent="openModal" />
                </tab-content>
                <tab-content :title="$t('account.wizzard.tracing')" icon="ti-alert">
                    <Tracing :modalType="pageSettings" :modalEvent="openModal" />
                </tab-content>
                <tab-content :title="$t('account.wizzard.communication')" icon="ti-signal ">
                    <div class="actions">
                        <b-button variant="success"  @click="openModal(true,'add')"> <b-icon icon="plus" /> {{$t('general.add')}} </b-button>
                    </div>
                    <Communication :modalType="pageSettings" :modalEvent="openModal" />
                </tab-content>
            </form-wizard>
        </b-card>
          <!-- Modals -->
        <DefinationModal v-if="modalType == 'Defination'" :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
        <CustomerModal v-if="modalType == 'Customer'" :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
        <Modals v-else :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />

    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import ZoneForm from './components/ZoneForm'
    import WorkHours from "@/components/WorkHours"
    import PanelUsersForm from "./components/PanelUsersForm"
    import NoteForm from "./components/NoteForm"
    import Exceptions from "./components/ExceptionsForm"
    import NotificationForm from "./components/NotificationForm"
    import Tracing from "./components/Tracing"
    import Communication from "./components/Communication"
    import Form from '@/components/Form'
    import DefinationModal from "@/pages/General/Defination/modals/"
    import CustomerModal from "@/pages/General/Customer/modals/"
    import {prepareRequestData, createEventAdditionalButton} from '@/assets/js/custom.js'
    import Forms from './forms'
    import jwt_decode from "jwt-decode";
    import Modals from "./modals/"
    import i18n from '@/plugins/i18n';

    let breadCrumb = []

    
    export default {
        name: 'AccountAdd',
        created: async function(){
            await this.$store.dispatch('getCustomerDetail', {id: this.$route.params.id})
            await this.$store.dispatch('customeraddresses_get', {parent_id: this.$route.params.id} )
            this.getFormData('GeneralForms')
        },
        computed:{
            customerData(){
                 this.breadCrumb = [
                    { label: this.$store.getters.getCustomerData.name, url: "/Customer/"+this.$route.params.id },
                    { label: i18n.t('pages.account.name'), url: "/Accounts/List" },
                    { label: i18n.t('pages.account.add'), url: "/Accounts/Add/"+this.$route.params.id }
                ]
                return this.$store.getters.getCustomerData
            },
            message(){
                return this.$store.getters.getAccountStatus
            },
            accountId(){
                return this.$store.getters.accountId
            },
             loading(){
                return this.$store.getters.getAccountLoading
            },
            hourList(){
                return this.$store.getters.getAccountHours
            },
            accountTypes(){
                return this.$store.getters.getAccountTypes
            },
            getJWT(){
                return jwt_decode(localStorage.getItem('access_token'))
            }
        },
        data: function(){
            return{
                GeneralForms: Forms.GeneralForms,
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"Accounts",
                modalName: "",
                newButton: true,
                changeStepStatus: false,
                selectedIndex: 0,
            }
        },
        components:{
           Form, BreadCrumb, ZoneForm, WorkHours, PanelUsersForm, NoteForm, Modals, Exceptions, 
           NotificationForm, Tracing, Communication, DefinationModal, CustomerModal
        },
        methods:{
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            onComplete: function(isLastStep){
                if(isLastStep){
                    this.$router.push('/Accounts/List')
                }
            },
            pageSettings: function(state, form){
                this.newButton = state
                this.currentForm = form
                if(form == "WorkHours" || form == "WorkHoursEdit")
                    this.tolerans = true
                else
                    this.tolerans = false
            },
            changeStep: function(){
                return  this.$refs.GeneralForm.$refs.Form.validate().then( async success =>{
                    if(success){
                       let data = prepareRequestData(this.GeneralForms, this.$refs.GeneralForm.formData )
                        data.customerId = this.$route.params.id
                        await this.$store.dispatch('createAccount', data)
                        if(this.$store.getters.getAccountStatus.status == "Success"){
                            this.newButton = true
                            this.currentForm = "Zone"
                            this.tolerans = false
                            await this.$store.dispatch('getAccountZones', this.$store.getters.accountId && this.$store.getters.accountId.data )
                            return true
                        }else{
                            return false
                        }
                        
                    }else {
                        return false
                    }
                })
            },
            getFormData(data){
                switch(data){
                    case 'GeneralForms' :
                        break;
                        /*this.GeneralForms.map(async formData => {
                            switch(formData.name){
                                case 'accountType':
                                    await this.$store.dispatch('listAccountType')
                                    formData.additionalButton.event = async () => { 
                                        this.modalType = 'Defination'
                                        this.currentForm = formData.name
                                        this.openModal(true, 'add', {})
                                    }
                                    break;
                                case 'job':
                                    await this.$store.dispatch('listJobs')
                                    formData.additionalButton.event = async () => { 
                                        this.modalType = 'Defination'
                                        this.currentForm = formData.name
                                        this.openModal(true, 'add', {})
                                    }
                                    break;
                                case 'address':
                                    await this.$store.dispatch('getCustomerAddresses', {id: this.$route.params.id})
                                    formData.additionalButton.event = async () => { 
                                        this.$store.dispatch('listCountries')
                                        this.modalType = 'Customer'
                                        this.currentForm = 'Addresses'
                                        this.openModal(true, 'add', {})
                                    }
                                    break;
                                case 'brand':
                                    await this.$store.dispatch('listBrands')
                                    formData.additionalButton.event = async () => { 
                                        this.modalType = 'Defination'
                                        this.currentForm = 'Panel'
                                        this.openModal(true, 'add', {type: 'brand'})
                                    }
                                    break
                                case 'model':
                                    await this.$store.dispatch('listBrands')
                                    formData.additionalButton.event = async () => { 
                                        this.modalType = 'Defination'
                                        this.currentForm = 'Panel'
                                        this.openModal(true, 'add', {type: 'model', brand_id: this.$refs.GeneralForm.formData['brand'].id})
                                    }
                                    break
                                case 'protocol':
                                    await this.$store.dispatch('listProtocols')
                                    formData.additionalButton.event = async () => { 
                                        this.modalType = 'Defination'
                                        this.currentForm = 'SignalProtocol'
                                        this.openModal(true, 'add', {})
                                    }
                                    break;  
                                case 'accountCode': 
                                    await this.$store.dispatch('getNewAccountNumber', this.$route.params.id )
                                    this.$refs.GeneralForm.formData[formData.name] = this.$store.getters.getNewAccountNo
                                    formData.additionalButton.event = async () => { 
                                        await this.$store.dispatch('getNewAccountNumber', this.$route.params.id )
                                        this.$refs.GeneralForm.formData[formData.name] = this.$store.getters.getNewAccountNo
                                    }
                                    break;
                            }
                        })
                        break;*/
                }
            },
            /* Sayfa değitiğinde tektiklenecek event */
            handleTabChange: async function (prevIndex, nextIndex) {
                let params = {
                    accountId: this.$store.getters.accountId && this.$store.getters.accountId.data,
                    type: 2
                }
                this.selectedIndex = nextIndex

                switch(nextIndex){
                    case 0:
                        this.getFormData('GeneralForms')
                        await this.$store.dispatch('customeraddresses_get', {parent_id: this.$route.params.id} )
                        return true                
                    case 1:
                        if(prevIndex == 0){
                            return
                        } else {
                            this.newButton = true
                            this.currentForm = "Zone"
                            this.tolerans = false
                            await this.$store.dispatch('getAccountZones', this.$store.getters.accountId && this.$store.getters.accountId.data )
                            return true
                        }
                       
                    case 2:
                        this.newButton = true
                        this.currentForm = "WorkHoursModal"
                        this.tolerans = true
                        await  this.$store.dispatch('getAccountHours',params)
                        return true
                    case 3:
                        this.newButton = true
                        this.currentForm = "Exceptions"
                        this.tolerans = false
                        await  this.$store.dispatch('getAccountAlertDef',params)
                        await  this.$store.dispatch('getAlertDef', params)
                        return true;
                    case 4:
                        this.newButton = true
                        this.currentForm = "PanelUser"
                        this.tolerans = false
                        params.type = 0
                        this.$store.dispatch('getAccountUsers', params)
                        return true
                    case 5:
                        this.newButton = true
                        this.currentForm = "Notification"
                        this.tolerans = false
                        this.$store.dispatch('getAccountNotifications', params)
                        return true
                    case 6:
                        this.newButton = true
                        this.currentForm = "Note"
                        this.tolerans = false
                        await  this.$store.dispatch('getAccountNotes',params)
                        return true
                    case 7:
                        this.newButton = false
                        this.currentForm = "Tracing"
                        this.tolerans = false
                        await  this.$store.dispatch('getTracings',params)
                        return true
                    case 8:
                        this.newButton = true
                        this.currentForm = "Communications"
                        this.tolerans = false
                        await  this.$store.dispatch('getAccountComs',params)
                        return true
                }
            },
        },
    }
    /**
     * 
                    <GeneralForm ref="GeneralForm" :customer="{data: customerData ? customerData.ID : $route.params.id }" />
     */
</script>

<style lang="css" scoped > 
    @import "./styles/add.min.css"; 
</style>




// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/Add.vue